'use client';

import type { CatalogSearchParamsQuery } from '@wolfejs/ms-api-js/src/types/pgcorp';
import { useProducts } from '@wolfejs/ms-api-react/src';
import { ApiError } from '@wolfejs/ms-api-react/src/components/ApiError';
import ProductGridHeader from '@wolfejs/ms-ui/Products/Header';
import ProductGrid from '@wolfejs/ms-ui/Products/ProductGrid';
import { Pagination } from '@wolfejs/ui/Pagination';
import { Spinner } from '@wolfejs/ui/Spinner';
import { useEffect, useState } from 'react';
import type { PGCorpProduct } from '../../../../types/products';

const PAGE_NUMBER = 1;
const PAGE_SIZE = 25;

const defaultPagination = {
  pageNumber: PAGE_NUMBER,
  pageSize: PAGE_SIZE,
  search: undefined,
};

export const ProductsGridContainer = ({ params }: { params: { portalSlug: string } }) => {
  const [searchParams, setSearchParams] = useState<CatalogSearchParamsQuery>({ ...defaultPagination });
  const { data: productData, isLoading, refetch, error } = useProducts(searchParams);

  useEffect(() => {
    refetch();
  }, [searchParams]);

  if (error) return <ApiError error={error} />;

  const products = productData?.data as unknown as PGCorpProduct[];
  const pagination = productData?.pagination;
  const pageCount = pagination?.lastPage || 1;
  return (
    <div>
      <ProductGridHeader
        products={products}
        page={searchParams.pageNumber}
        limit={searchParams.pageSize}
        search={searchParams.search ?? ''}
        setSearch={newSearch => setSearchParams({ ...searchParams, pageNumber: 1, search: newSearch })}
        count={pagination?.itemsCount || 0}
      />
      {isLoading ? (
        <div className="flex h-[65vh] items-center justify-center">
          <Spinner color="var(--primary)" size={50} />
        </div>
      ) : (
        <>
          <ProductGrid products={products} params={params} />
          {pagination && (
            <Pagination
              currentPageIndex={searchParams.pageNumber - 1}
              pageCount={pageCount}
              onPageChange={pageIndex => setSearchParams({ ...searchParams, pageNumber: pageIndex + 1 })}
            />
          )}
        </>
      )}
    </div>
  );
};
